import type { OnDestroy, OnInit } from '@angular/core';
import { Directive, ElementRef, inject, output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[ctrl-click]',
})
export class CtrlClickDirective implements OnInit, OnDestroy {
  readonly ctrlClickEvent = output({ alias: 'ctrl-click' });

  readonly #renderer = inject(Renderer2);
  readonly #element = inject(ElementRef);

  #unlisten: any;

  ngOnInit(): void {
    this.#unlisten = this.#renderer.listen(this.#element.nativeElement, 'click', (event) => {
      if (event.ctrlKey || event.metaKey) {
        event.preventDefault();
        event.stopPropagation();

        // unselect accidentally selected text (browser default behaviour)
        document.getSelection()?.removeAllRanges();

        this.ctrlClickEvent.emit(event);
      }
    });
  }

  ngOnDestroy(): void {
    this.#unlisten();
  }
}
